import { updateConsent } from './gtm';
import { COOKIES_VERSION } from '../data/legalEntity';

export const CONSENT_STORAGE_KEY = 'aipsyhelp_cmp_v2';
export const CONSENT_EVENT = 'aipsyhelp:consent-change';

const DEFAULT_DENIED = {
  essential: true,
  analytics: false,
  advertising: false
};

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

export function getConsentRecord() {
  if (typeof window === 'undefined') return null;
  const modern = safeParse(window.localStorage.getItem(CONSENT_STORAGE_KEY));
  if (modern && modern.version) return modern;

  const legacyAccepted = window.localStorage.getItem('cookieConsentAccepted');
  if (legacyAccepted === null) return null;
  const legacySettings = safeParse(window.localStorage.getItem('cookieConsentSettings')) || {};
  return {
    version: 'legacy',
    decided: true,
    accepted: legacyAccepted === 'true',
    categories: {
      essential: true,
      analytics: Boolean(legacySettings.analytics),
      advertising: Boolean(legacySettings.advertising)
    },
    decidedAt: window.localStorage.getItem('cookieConsentDate') || null
  };
}

export function hasConsentDecision() {
  const record = getConsentRecord();
  return Boolean(record && record.decided);
}

export function getConsentCategories() {
  const record = getConsentRecord();
  if (!record) return { ...DEFAULT_DENIED };
  return { ...DEFAULT_DENIED, ...(record.categories || {}) };
}

export function isAnalyticsAllowed() {
  return getConsentCategories().analytics === true;
}

export function isAdvertisingAllowed() {
  return getConsentCategories().advertising === true;
}

export function persistConsent(categories, source = 'banner') {
  const next = {
    version: COOKIES_VERSION,
    decided: true,
    accepted: Boolean(categories.analytics || categories.advertising),
    categories: {
      essential: true,
      analytics: Boolean(categories.analytics),
      advertising: Boolean(categories.advertising)
    },
    source,
    decidedAt: new Date().toISOString()
  };

  window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(next));
  window.localStorage.setItem('cookieConsentAccepted', next.accepted ? 'true' : 'false');
  window.localStorage.setItem('cookieConsentDate', next.decidedAt);
  window.localStorage.setItem(
    'cookieConsentSettings',
    JSON.stringify({ analytics: next.categories.analytics, advertising: next.categories.advertising })
  );

  applyConsentToTags(next.categories);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: next }));
  return next;
}

export function applyConsentToTags(categories = getConsentCategories()) {
  if (categories.analytics && categories.advertising) {
    updateConsent('all');
  } else if (categories.analytics) {
    updateConsent('analytics');
  } else if (categories.advertising) {
    updateConsent('ads');
  } else {
    updateConsent('none');
  }
}

export function consentModeLabel(categories = getConsentCategories()) {
  if (categories.analytics && categories.advertising) return 'granted_all';
  if (categories.analytics) return 'analytics_only';
  if (categories.advertising) return 'ads_only';
  return 'denied';
}
